import api from './api';

export interface CancelledIncome {
  id: number;
  bookingId: string;
  customerName: string;
  project: {
    id: number;
    name: string;
  };
  unitNumber: string;
  unitDisplay: string;
  totalSaleDeedAmount: number;
  totalReceivedAmount: number;
  finalCancelAmount: number;
  givenCancelAmount: number;
  pendingCancelAmount: number;
  cancellationDate: string | null;
  cancellationReason: string | null;
}

export interface CancelTransaction {
  id: number;
  amount: number;
  refundDate: string;
  paymentMethod: string;
  referenceNumber: string;
  bankName?: string;
  remarks: string;
  processedBy: string;
}

export interface SearchCancelledBookingsParams {
  projectId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface AddCancelAmountData {
  bookingId: number;
  amount: number;
  description?: string;
  paymentMethod?: string;
  referenceNumber?: string;
  bankName?: string;
  instrumentDate?: string;
}

export const cancelIncomeService = {
  // Search cancelled bookings
  searchCancelledBookings: async (params: SearchCancelledBookingsParams, signal?: AbortSignal) => {
    const queryParams = new URLSearchParams();
    
    if (params.projectId) {
      queryParams.append('projectId', params.projectId);
    }
    if (params.search) {
      queryParams.append('search', params.search);
    }
    if (params.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    const response = await api.get(`/cancel-income/cancelled-bookings?${queryParams.toString()}`, {
      signal
    });
    return response.data;
  },

  // Get cancel transactions for a booking
  getBookingTransactions: async (bookingId: number) => {
    const response = await api.get(`/cancel-income/booking/${bookingId}/transactions`);
    return response.data;
  },

  // Add new cancel amount
  addCancelAmount: async (data: AddCancelAmountData) => {
    const response = await api.post('/cancel-income/add-cancel-amount', data);
    return response.data;
  },

  // Delete a cancel income transaction (superadmin only)
  deleteTransaction: async (transactionId: number) => {
    const response = await api.delete(`/cancel-income/transaction/${transactionId}`);
    return response.data;
  }
};